import axios from 'axios';

import {
  getV1RootUrl,
  getV2RootUrl,
  publicAxiosHeader,
  publicAxiosHeaderV2
} from 'common/helpers/apiHelper';

export const getCart = (cartId) =>
  axios.get(`${getV2RootUrl()}/cart/${cartId}`, publicAxiosHeaderV2());

export const getCartForSharing = (cartId) => {
  return axios.get(
    `${getV2RootUrl()}/cart/${cartId}/for-sharing`,
    publicAxiosHeaderV2()
  );
};

export const addItem = (cartId, item) =>
  axios.post(
    `${getV2RootUrl()}/cart/${cartId}/item`,
    item,
    publicAxiosHeaderV2()
  );

export const createCart = (cart) =>
  axios.post(`${getV2RootUrl()}/cart`, cart, publicAxiosHeaderV2());

export const updateCart = (cartId, cart) =>
  axios.put(`${getV2RootUrl()}/cart/${cartId}`, cart, publicAxiosHeaderV2());

export const authenticateForFullSteamWallet = (cartId) =>
  axios.post(
    `${getV2RootUrl()}/payment/${cartId}/fullsteam/auth-digital-wallet`,
    {},
    publicAxiosHeaderV2()
  );

export const chargeFullSteamWallet = (cartId, accountId) =>
  axios.post(
    `${getV2RootUrl()}/payment/${cartId}/fullsteam/charge-digital-wallet`,
    { accountId },
    publicAxiosHeaderV2()
  );

export const createPaymentIntentCart = (cartId, params) =>
  axios.post(
    `${getV2RootUrl()}/payment/${cartId}/stripe/payment-intent`,
    params,
    publicAxiosHeaderV2()
  );

export const recordPaymentIntentCart = (cartId, paymentIntentId) =>
  axios.put(
    `${getV2RootUrl()}/payment/${cartId}/stripe/record-payment-intent`,
    { paymentIntentId },
    publicAxiosHeaderV2()
  );

export const replaceTenderOnCart = (cartId, tender) =>
  axios.post(
    `${getV2RootUrl()}/cart/${cartId}/tender/replace`,
    tender,
    publicAxiosHeaderV2()
  );

export const chargeCart = (cartId, data) =>
  axios.put(
    `${getV2RootUrl()}/cart/${cartId}/charge`,
    data,
    publicAxiosHeaderV2()
  );

export const verifyPayStackAPI = (cartId, data) =>
  axios.put(
    `${getV2RootUrl()}/payment/${cartId}/paystack/verify`,
    data,
    publicAxiosHeaderV2()
  );

export const removeItem = (cartId, itemId, useLoyaltyPoints) => {
  if (useLoyaltyPoints) {
    return axios.delete(
      `${getV2RootUrl()}/cart/${cartId}/item/${itemId}?useLoyaltyPoints=true`,
      publicAxiosHeaderV2()
    );
  }
  return axios.delete(
    `${getV2RootUrl()}/cart/${cartId}/item/${itemId}`,
    publicAxiosHeaderV2()
  );
};

export const updateItem = (cartId, itemId, item) =>
  axios.put(
    `${getV2RootUrl()}/cart/${cartId}/item/${itemId}`,
    item,
    publicAxiosHeaderV2()
  );

export const addCouponCode = (cartId, data) =>
  axios.post(
    `${getV2RootUrl()}/cart/${cartId}/coupon`,
    data,
    publicAxiosHeaderV2()
  );

export const addGiftCard = (cartId, data) =>
  axios.post(
    `${getV2RootUrl()}/cart/${cartId}/gift-card`,
    data,
    publicAxiosHeaderV2()
  );

export const getShippingRatesAndTaxes = (
  cartId,
  stateCode,
  countryCode,
  zipCode
) =>
  axios.get(
    `${getV1RootUrl()}/cart/${cartId}/shipping-rate-and-taxes?stateCode=${stateCode}&countryCode=${countryCode}&zipCode=${zipCode}`,
    publicAxiosHeader()
  );

export const getCartTax = (cartId, queryString) =>
  axios.get(
    `${getV2RootUrl()}/cart/${cartId}/tax-for-shipping-service?${queryString}`,
    publicAxiosHeaderV2()
  );

export const addLoyaltyTender = (cartId, data) =>
  axios.post(
    `${getV2RootUrl()}/cart/${cartId}/tender`,
    data,
    publicAxiosHeaderV2()
  );

export const removeTender = (cartId, tenderId) =>
  axios.delete(
    `${getV2RootUrl()}/cart/${cartId}/tender/${tenderId}`,
    publicAxiosHeaderV2()
  );

export const sendCartToHostedPayment = (cartId) =>
  axios.post(
    `${getV1RootUrl()}/cart/${cartId}/tender/hosted-payment`,
    null,
    publicAxiosHeader()
  );
